import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  USER_ENABLE_REQUEST,
  userEnabled,
  userEnableError,
} from "../../actions/users";
import { role as roleSelector, ADMIN } from "../../selectors/auth";
import scEnableUser from "../../../../../backend/oncall/administration/users/enable";
import partnerEnableUser from "../../../../../backend/oncall/partners/users/enable";

const enable = function*(action) {
  try {
    const role = yield select(roleSelector);
    const enableUser = role === ADMIN ? scEnableUser : partnerEnableUser;
    yield call(enableUser, action.payload.username);
    yield put(userEnabled());
  } catch (error) {
    yield put(userEnableError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(USER_ENABLE_REQUEST, enable);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/users/request-enable.js